/**
 * SINGLE SOURCE OF TRUTH for links and business facts.
 * Every "Book" button on the site uses BOOKING_URL.
 */
export const BOOKING_URL = 'https://packages.hpptraining.com';

/** "See Full Calendar" destination — point this at the live class calendar. */
export const CALENDAR_URL = 'https://packages.hpptraining.com';

export const STUDENT_LOGIN_URL = 'https://packages.hpptraining.com';

export const SITE = {
  name: 'Homeland Personal Protection',
  shortName: 'HPP Training',
  legalName: 'Homeland Personal Protection LLC',
  url: 'https://hpptraining.com',
  logo: 'https://hpptraining.com/wp-content/uploads/2024/02/Gradient-Shiled_With_Homeland-Text-300x95-1.png',
  phoneDisplay: '(702) 375-5900',
  phoneHref: 'tel:+17023755900',
  since: 2010,
  studentsTrained: '14,000+',
  googleRating: 4.9,
  hours: [
    { days: 'Classes', time: '7 days a week' },
    { days: 'Phone', time: 'Daily, 8:00am – 6:00pm' },
  ],
  location: {
    shortName: 'Bass Pro Shops – Silverton',
    venue: 'Bass Pro Shops, Conservation Room (2nd floor)',
    street: '8200 Dean Martin Dr',
    city: 'Las Vegas',
    region: 'NV',
    postal: '89139',
    area: 'Silverton Village',
    mapEmbed:
      'https://www.google.com/maps?q=Bass+Pro+Shops+8200+Dean+Martin+Dr+Las+Vegas+NV+89139&output=embed',
    mapLink: 'https://maps.google.com/?q=Bass+Pro+Shops+8200+Dean+Martin+Dr+Las+Vegas+NV+89139',
  },
  social: {
    ccwMaggie: 'https://www.facebook.com/CCWMaggie',
    womensDefenseNetwork: 'https://www.facebook.com/womensdefensenetwork',
  },
  usccaPartner: 'https://usccapartners.com/hpptraining',
  googleReviews: 'https://www.google.com/search?q=Homeland+Personal+Protection+Las+Vegas+reviews',
  facebookReviews: 'https://www.facebook.com/CCWMaggie/reviews',
};
